module.exports = __webpack_public_path__ + "static/Pandora-82a0b8fdc3346be56b6a911501a0ee77.png";